import { Directive, ElementRef, Input } from '@angular/core';
import { createElement, generatorQuerySelector } from '@serviceos-ng/core';
import Cleave from 'cleave.js';

@Directive({
    selector: '[serviceosWebInputFormatter]',
})
export class InputFormatterDirective {
    /**
     * Import the TextField directive to catch the input change
     */
    @Input()
    public fsCardFields;

    @Input()
    public fieldType = ''; // 'cardNumber' | 'expiry' | 'cvv' | 'date-picker'

    constructor(private el: ElementRef) {}

    /**
     * Listener for change of input data
     */
    public ngAfterContentInit() {
        this.specialTypeRestrict();
    }

    private specialTypeRestrict() {
        const elementUniqueSelector = generatorQuerySelector.addElementUniqueSelector(
            this.el
        );
        switch (this.fieldType) {
            case 'cardNumber':
                {
                    const parentElement = this.el.nativeElement.parentElement;

                    parentElement.classList.add('cc-number');

                    const cardIconElement = createElement.generate(
                        parentElement,
                        'SPAN',
                        { class: 'card-icon' }
                    );

                    const cardElement = new Cleave(
                        `.${elementUniqueSelector.selector}`,
                        {
                            creditCard: true,
                            onCreditCardTypeChanged: (type) => {
                                this.el.nativeElement.parentElement.classList.remove(
                                    ...[
                                        'amex',
                                        'maestro',
                                        'visa',
                                        'mastercard',
                                        'diners',
                                        'jcb',
                                        'discover',
                                    ] // ! FIX: array with cards?!? What sup-credit-cards.ts then do?
                                );
                                this.el.nativeElement.parentElement.classList.add(
                                    type
                                );
                            },
                        }
                    );
                }
                break;
            case 'expiry':
                {
                    this.el.nativeElement.classList.add('cc-exp');
                    const exp = new Cleave(
                        `.${elementUniqueSelector.selector}`,
                        {
                            date: true,
                            datePattern: ['m', 'y'],
                        }
                    );
                }
                break;
            case 'cvv':
                {
                    this.el.nativeElement.classList.add('cc-csc');
                    const csc = new Cleave(
                        `.${elementUniqueSelector.selector}`,
                        {
                            date: true,
                            datePattern: ['Y'],
                        }
                    );
                }
                break;
            default:
                break;
        }
    }
}
